<div id="not-found">
  <div class="sba-card">
    <h2>{{"common.notFoundTitle" | translate}}</h2>
    <p>{{"common.notFoundMessage" | translate}}.</p>
  </div>
</div>